document.addEventListener('DOMContentLoaded', function() {
  const menuItems = document.querySelectorAll('.header__menu-item-wrapper');
  const categories = document.querySelectorAll('.mega-menu__category');
  let currentMenu = null;
  let timeoutId = null;

  // 测试时默认显示第一个 mega menu 和其第一个二级菜单
  // const firstMenuItem = menuItems[0];
  // const firstMegaMenu = firstMenuItem?.querySelector('.mega-menu__wrapper');
  // if (firstMegaMenu) {
  //   firstMegaMenu.style.display = 'flex';
  //   currentMenu = firstMegaMenu;
    
  //   // 显示第一个二级菜单
  //   const firstCategory = firstMegaMenu.querySelector('.mega-menu__category');
  //   const menuName = firstCategory?.dataset.menuName;
  //   const firstContent = document.querySelector(`.mega-menu__content[data-menu-name="${menuName}"]`);
  //   if (firstContent) {
  //     firstContent.classList.add('active');
  //   }
  // }
  // return;

  // the first menuItems's mega-menu__category-title should be active by default
  // 处理主菜单的hover
  menuItems.forEach(item => {
    const megaMenu = item.querySelector('.mega-menu__wrapper');

    if (megaMenu) {
      item.addEventListener('mouseenter', () => {
        document.querySelectorAll('.mega-menu__category-title.active').forEach(title => {
          title.classList.remove('active');
        });
        // if (megaMenu.dataset.realMega === 'true') {
        //   item.querySelector('.mega-menu__category-title')?.classList.add('active');
        // }

        clearTimeout(timeoutId);
        if (currentMenu && currentMenu !== megaMenu) {
          currentMenu.style.display = 'none';
        }
        megaMenu.style.display = 'flex';
        currentMenu = megaMenu;

        const header = document.querySelector('header.header');
        console.log('mega menu mouseenter', header);
        console.log('mega menu mouseenter', item);
        if (header) {
          header.classList.add('is-fixed-2');
        }
        const firstCategory = megaMenu.querySelector('.mega-menu__category');
        const allCategory = megaMenu.querySelectorAll('.mega-menu__category');
        allCategory.forEach(category => {
          const innerMenuName=category?.dataset.menuName;
          const innerContent = document.querySelector(`.mega-menu__content[data-menu-name="${innerMenuName}"]`);
          if (innerContent) {
            innerContent.classList.remove('active');
          }
        })
        const menuName = firstCategory?.dataset.menuName;
        const firstContent = megaMenu.querySelector(`.mega-menu__content[data-menu-name="${menuName}"]`);
        const allContents = megaMenu.querySelectorAll('.mega-menu__content');
        console.log('allContents', allContents.length);
        if (firstContent && allContents.length ==1) {
          firstContent.classList.add('active');
        }
      });

      item.addEventListener('mouseleave', (e) => {
        if (!e.relatedTarget || !megaMenu.contains(e.relatedTarget)) {
          const movementX = Math.abs(e.clientX - e.target.getBoundingClientRect().x);
          const movementY = Math.abs(e.clientY - e.target.getBoundingClientRect().y);
          
          // Add a threshold for more accurate direction detection
          const isHorizontalMovement = movementX > movementY && movementY < 50; // Only consider horizontal if vertical movement is small
          
          const delay = isHorizontalMovement ? 200: 150;

          timeoutId = setTimeout(() => {
            megaMenu.style.display = 'none';
            currentMenu = null;
            const header = document.querySelector('header.header');
            if (header) {
              header.classList.remove('is-fixed-2');
            }
          }, delay);
        }
      
      });
    }
  });

  // 处理二级菜单的hover
  categories.forEach(category => {
    let hoverTimer;

    category.addEventListener('mouseenter', () => {
      // Set a timer for 300ms before activating the menu
      hoverTimer = setTimeout(() => {
        const menuName = category.dataset.menuName;
        const contents = document.querySelectorAll('.mega-menu__content');
        // Remove .active from all other titles
        document.querySelectorAll('.mega-menu__category-title.active').forEach(title => {
          title.classList.remove('active');
        });
        console.log('mouseenter', category);
        // Active the current title
        category.querySelector('.mega-menu__category-title')?.classList.add('active');
        
        contents.forEach(content => {
          if (content.dataset.menuName === menuName) {
            content.classList.add('active');
          } else {
            content.classList.remove('active');
          }
        });
      }, 300); // 300ms delay
    });

    // Cancel the timer if mouse leaves before 300ms
    category.addEventListener('mouseleave', () => {
      if (hoverTimer) {
        clearTimeout(hoverTimer);
        hoverTimer = null;
      }
    });
  });
}); 